import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-widgets',
  templateUrl: './widgets.component.html',
  styleUrls: ['./widgets.component.css']
})
export class widgetsComponent implements OnInit {

  @Input() title:any;
  @Input() icon:any;
  @Input() value:any;
  @Input() per:any;
  @Input() width:any;
  @Input() bgcolor:any;

  @Input() widgets:boolean;
 
  constructor() { }

  ngOnInit() {
    //console.log("testing",this.widgets);
    
    
  }

}
